import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceReformsComponent } from "./maintenance-reforms.component";
import { ListReformsComponent } from "./list-reforms/list-reforms.component";
import { EditReformsComponent } from "./edit-reforms/edit-reforms.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesReforms: Routes = [
  {
    path: "",
    component: MaintenanceReformsComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListReformsComponent,
      },
      {
        path: "edicion/:id",
        component: EditReformsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesReforms)],
  exports: [RouterModule],
})
export class ReformsRoutingModule {}
